import { recursivelyRemoveEdgesAndNodes } from 'api/shopifyV2/utils';
import { SHOPIFY_ADMIN_API_URL, SHOPIFY_API_VERSION } from 'config/base';
import { getShopifyAdminApiHeaders } from 'config/server';
import request from 'graphql-request';
import { StoreEnum } from 'schema/storeCode';
import { getProductsInventoryByVariantIds } from './getProductsInventoryByVariantIds.gql';
import type { GetProductsInventoryByVariantIdsResponse } from './types';
import { createFilterQueryFromProducts } from './utils';

const API_VERSION_OVERRIDE = '2024-10';

export async function getProductsInventoryByVariantId(productVariants: string[], store: StoreEnum) {
  if (!productVariants.length) {
    return null;
  }
  const filterQuery = createFilterQueryFromProducts(productVariants);
  const shopifyURL = SHOPIFY_ADMIN_API_URL[store].replace(
    SHOPIFY_API_VERSION,
    API_VERSION_OVERRIDE
  );

  const response = await request<GetProductsInventoryByVariantIdsResponse>({
    url: shopifyURL,
    document: getProductsInventoryByVariantIds,
    variables: { query: filterQuery },
    requestHeaders: getShopifyAdminApiHeaders(store)
  });

  return recursivelyRemoveEdgesAndNodes(response);
}
